import { ClearButton } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/components/clearButton";
import { Item } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/components/item";
import { Items } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/components/items";
import { Base } from "@/components/Search/SearchBar/components/ResultsPanel/components/Results/RecentSearches/recentSearches.base";

export const RecentSearches = Object.assign(Base, {
    Items: Items,
    Item: Item,
    ClearButton: ClearButton
});
